import { Button } from 'primereact/button';
import {useEffect, useState } from 'react';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InvoiceUserModel } from '../../models/orders/order-list-model';
import UserAddressService from '../../services/useraddress/useraddress.service';
 
interface SearchPanelProps {
    onSearch: (query:any) => void;
}
 
const CashCollectionReportListSearch: React.FC<SearchPanelProps> = ({ onSearch }) => {
 
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const [startDate, setStartDate] = useState<any>();
    const [endDate, setEndDate] = useState<any>();
    const [invoicedList,setInvoicedList] = useState<InvoiceUserModel[]>([]);
    const [searchInvoiceBy, setSearchInvoiceBy] = useState<any>(null);
    
    useEffect(() => {
     UserAddressService.getInvoiceUsers().then(r =>  setInvoicedList(r))
    }, []);

    function handleSearch(){
     var data =
      {
        userId : searchInvoiceBy,
        startDate : startDate,
        endDate : endDate
      }
      onSearch(data)
    }

    function handleReset(){
      setEndDate(null);
      setStartDate(null);
      setSearchInvoiceBy(null);
           var data =
      {
        userId : searchInvoiceBy,
        startDate : null,
        endDate : null
      }
      onSearch(data)
    }

    return (
        <div className="card p-3 w-full">
            <div className='grid'>
                <div className="col-12 md:col-6 lg:col-3 mb-3">
                  <Dropdown
                    id="SearchUser"
                    name="SearchUser"                                                      
                    options={invoicedList}
                    optionLabel="displayName"
                    optionValue="userID"
                    value={searchInvoiceBy}
                    onChange={(e) => setSearchInvoiceBy(e.target.value)}
                    filter
                    placeholder="Invoice By" style={{ width: "100%" }}
                  />
                </div>
                <div className="col-12 md:col-6 lg:col-3 mb-3">
                 <Calendar value={startDate} onChange={(e) => setStartDate(e.value)}
                  dateFormat="dd/mm/yy" style={{ width: "50%" }}
                  placeholder="start date" />
                 <Calendar value={endDate} onChange={(e) => setEndDate(e.value)}
                  dateFormat="dd/mm/yy" style={{ width: "50%" }}
                  placeholder="end date" />
                </div>
                    <div className='col-12 md:col-6 lg:col-3'>
                       <Button className="w-full" label="Filter" style={{ width: "100%" }} onClick={handleSearch} severity="success"></Button>
                    </div>
                    <div className='col-12 md:col-6 lg:col-3'>
                       <Button className="w-full" raised label="Reset"  onClick={handleReset} severity="secondary"></Button>
                    </div>
            </div>
        </div>
    );
};

export default CashCollectionReportListSearch;
